import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IAlert } from '../../services/alert/alert';
import { AlertType } from '../../services/alert/alert-type';
import { AlertService } from '../../services/alert/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe],
})
export class AlertComponent implements OnInit, OnDestroy {
  public alertTypes = AlertType;
  public alerts: IAlert[] = [];

  private alertsSub?: Subscription;

  private alertService = inject(AlertService);

  ngOnInit(): void {
    this.alertsSub = this.alertService.alert$.subscribe({
      next: (alert: IAlert) => {
        this.addAlert(alert.title, alert.text, alert.type, alert.operationId, alert.timestamp, alert.dismissable);
      },
    });
  }

  ngOnDestroy(): void {
    this.alertsSub?.unsubscribe();
  }

  public removeAlert(alert: IAlert): void {
    const index = this.alerts.indexOf(alert); // Find index in your array.
    this.alerts.splice(index, 1); // Remove element from array.
  }

  private addAlert(
    title: string,
    text: string,
    type: AlertType = AlertType.Danger,
    operationId?: string,
    timestamp?: Date,
    dismissable: boolean = true,
    autoRemoveAfter: number = 30000,
  ): IAlert {
    const alert = {
      title,
      text,
      type,
      operationId,
      timestamp,
      dismissable,
    } as IAlert;

    this.alerts.push(alert);

    if (autoRemoveAfter !== 0) {
      setTimeout(() => {
        this.removeAlert(alert);
      }, autoRemoveAfter);
    }

    return alert;
  }
}
